import React, { FC, ReactElement, useState } from 'react';
import axios from 'axios';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import api, {OP_TYPE_ENU} from 'api/xqjy-service';
import styles from './index.less';

interface IProps {
  shortCode: string,
  children?: React.ReactNode,
  resId?: number
}

const Download: FC<IProps> = (props:IProps) : ReactElement=> {

  const {shortCode, resId, children} = props

  const [loading, setLoading] = useState(false)

  const dl = ()=>{
    setLoading(true)
    if(resId) {
      api.res.oplog(resId, OP_TYPE_ENU.DOWNLOAD)
    }
    api.file.detail(shortCode).then(result=>{
      if(result!=null && result.data != null){
        const {url, fileName} = result.data
        axios({
          method: 'get',
          responseType:'blob',
          url: url
        }).then((res:any)=>{
            var blob = new Blob([res.data],{type: res.headers['content-type']});
            var downloadElement = document.createElement('a');
            var href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            setLoading(false)
        }).catch(e=>{
          setLoading(false)
        })
      }else{
        setLoading(false)
      }
    }).catch(e=>{
      setLoading(false)
    })
  }

  const DownloadBtn = ()=>{
    return (
      <>
        { !loading && <a className="abtn" onClick={dl}><i></i></a> }
        { loading && <LoadingOutlined /> }
      </>
    )
  }

  return (
    <>
      {
        children&&
        <Spin size="small" spinning={loading}>
          <div className={styles.main} onClick={dl}>{children}</div>
        </Spin>
      }
      {
        !children &&
        <DownloadBtn/>
      }
    </>
  )
}

export default Download